module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_9016.6cd2cb14.png";